import { createAsyncThunk } from '@reduxjs/toolkit';

export const resetAll = createAsyncThunk(
  'resetAll',
  async (_payload, thunkAPI) => {
    thunkAPI.dispatch({ type: 'resetAll' });
  },
);
